import fetcher from 'api/fetcher';
import { PAGE_SIZE } from 'utils/constants/campaign';

import urlParser from 'bloko/common/urlParser';

import { convertCampaignsToMap } from 'components/CampaignsDashboard/utils/utils';

import {
    DashboardCampaign,
    setCampaigns,
    setCampaignsCurrentPage,
    setCheckedCampaignIds,
    setIsCampaignsDetailsLoading,
    setIsCampaignsLoading,
    setIsCampaignsStatisticsLoading,
} from 'store/models/campaignsDashboard';
import { AppliedCampaignsFilters } from 'store/models/campaignsFilters';
import { AppThunkAction } from 'store/utils';

export const fetchCampaigns = ({
    abortSignal,
    searchValue,
    filters,
}: {
    abortSignal: AbortSignal;
    searchValue?: string;
    filters?: AppliedCampaignsFilters;
}): AppThunkAction => {
    return (dispatch, getState) => {
        const nameFilter = searchValue === undefined ? getState().campaignsFilters.campaignsSearchValue : searchValue;
        const appliedCampaignsFilters =
            filters === undefined ? getState().campaignsFilters.appliedCampaignsFilters : filters;

        dispatch([
            setIsCampaignsLoading(true),
            setIsCampaignsDetailsLoading(true),
            setIsCampaignsStatisticsLoading(true),
        ]);

        const {
            productTypes,
            campaignStatuses,
            budgetStatuses,
            moderationStatuses,
            areas,
            professionalRoles,
            createdByUserIds,
        } = appliedCampaignsFilters;

        const tab = getState().campaignsDashboard.campaignsCurrentTab;

        const queryStr = urlParser.stringify({
            tab,
            page: 1,
            pageSize: PAGE_SIZE,
            nameFilter,
            productType: [...productTypes],
            campaignStatus: [...campaignStatuses],
            budgetStatus: [...budgetStatuses],
            moderationStatus: [...moderationStatuses],
            area: [...areas],
            professionalRoles: [...professionalRoles],
            createdByUserIds: [...createdByUserIds],
        });

        return fetcher
            .get<unknown, DashboardCampaign[]>(`/api/v2/campaigns/?${queryStr}`, {
                signal: abortSignal,
                timeout: 30000,
            })
            .then((campaigns) => {
                const campaignsMap = convertCampaignsToMap(campaigns);
                dispatch([
                    setCampaignsCurrentPage(1),
                    setCampaigns(campaignsMap),
                    setCheckedCampaignIds(new Set()),
                    setIsCampaignsLoading(false),
                    setIsCampaignsDetailsLoading(true),
                    setIsCampaignsStatisticsLoading(true),
                ]);
            })
            .catch((error) => {
                if (abortSignal.aborted) {
                    return;
                }

                dispatch([
                    setIsCampaignsLoading(false),
                    setIsCampaignsDetailsLoading(false),
                    setIsCampaignsStatisticsLoading(false),
                ]);

                throw error;
            });
    };
};
